import { render } from "./UltraCardComment.vue?vue&type=template&id=4aab7517&scoped=true"
import script from "./UltraCardComment.vue?vue&type=script&lang=js"
export * from "./UltraCardComment.vue?vue&type=script&lang=js"

import "./UltraCardComment.vue?vue&type=style&index=0&id=4aab7517&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aab7517"]])

export default __exports__